<template>
  <div class="bg">
    <div class="loading">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'loading',
  data() {
    return {
    }
  },
  computed: {

  },
  mounted() {
  },
  methods: {},
  components: {}
}
</script>
<style  scoped>
.bg {
  min-height: 160px;
    height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading {
  width: 80px;
  height: 40px;
  margin: 0 auto;
}

.loading span {
  display: inline-block;
  width: 8px;
  height: 100%;
  border-radius: 4px;
  background: lightgreen;
  animation: load 1s ease infinite;
  -webkit-animation: load 1s ease infinite;
}

@keyframes load {
  0%,
  100% {
    height: 40px;
    background: lightgreen;
  }
  50% {
    height: 70px;
    margin: -15px 0;
    background: lightblue;
  }
}

@-webkit-keyframes load {
  0%,
  100% {
    height: 40px;
    background: lightgreen;
  }
  50% {
    height: 70px;
    margin: -15px 0;
    background: lightblue;
  }
}

.loading span:nth-child(2) {
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}

.loading span:nth-child(3) {
  -webkit-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

.loading span:nth-child(4) {
  -webkit-animation-delay: 0.6s;
  animation-delay: 0.6s;
}

.loading span:nth-child(5) {
  -webkit-animation-delay: 0.8s;
  animation-delay: 0.8s;
}
</style>



// WEBPACK FOOTER //
// loading.vue?105ae2d3